<template>
  <div style="position: relative">
    <!-- Button  -->
    <v-layout class="pl-2">
      <v-flex
        mb-6
        shrink
        :class="'icon_' + colorBtn"
        style="border-radius: 5px;"
        @click="
          onClickCategory({ id: cateId, name_th: textBtn, name_en: iconBtn })
        "
      >
        <v-layout class="menu-lists pa-2 ">
          <v-flex class="d-flex justify-center align-center shrink">
            <v-img
              lazy-src="https://picsum.photos/id/11/10/6"
              max-height="30"
              max-width="30"
              :src="checkIcon(iconBtn)"
            ></v-img>
          </v-flex>
          <v-flex class="mx-3 d-flex justify-center align-center shrink">
            {{ switchLanguage === "th" ? textBtn : iconBtn }}
          </v-flex>
          <v-flex class="d-flex justify-center align-center shrink">
            {{ totalPortfolio }}
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Button next/pre-->
    <div class="pa-0 ma-0 slide-btn-pre" @click="back()">
      <span class="material-icons" style="font-size: 24px;font-weight: bold">
        chevron_left
      </span>
    </div>
    <div class="slide-btn-next" @click="next($event)">
      <span class="material-icons" style="font-size: 24px;font-weight: bold">
        chevron_right
      </span>
    </div>

    <!-- Card  -->
    <div style="width:100%;height:auto;">
      <!-- Using the slider component -->
      <slider ref="slider" :options="currentOptions">
        <!-- slideritem wrapped package with the components you need -->
        <slideritem
          v-for="(item, i) in portfolios"
          :key="i"
          class="pa-2 slide-width"
        >
          <v-hover
            v-slot:default="{ hover }"
            open-delay="50"
            style="cursor: pointer;background-color: white"
          >
            <v-card width="100%" @click="viewPortDetail(item)" flat>
              <v-layout>
                <v-flex>
                  <v-img
                    lazy-src="../../assets/tcdc-color.png"
                    :src="
                      item.cover_img_path
                        ? url + imgPath + 'images_cover/' + item.cover_img_path
                        : require('../../assets/tcdc-color.png')
                    "
                    class="img-content-cover"
                    :contain="item.cover_img_path ? false : true"
                    aspect-ratio="1"
                  >
                    <v-expand-transition>
                      <div
                        v-if="hover"
                        class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                        style="height: 100%;"
                      >
                        <span
                          style="font-size: 16px;font-weight: bold"
                          class="text-uppercase"
                          >see detail</span
                        >
                      </div>
                    </v-expand-transition>
                  </v-img>
                </v-flex>
              </v-layout>
              <v-layout
                class="px-2 py-1 layout-slide-button d-flex align-center"
                style="background-color: #fff"
              >
                <v-flex class="shrink mr-2">
                  <v-img
                    :src="
                      item.profile &&
                      item.profile.mem_info &&
                      item.profile.mem_info.avatar
                        ? url +
                          imgPath +
                          'images_profile/' +
                          item.profile.mem_info.avatar
                        : require('../../assets/user_profile.png')
                    "
                    height="30px"
                    width="30px"
                    style="border-radius: 100%"
                  />
                </v-flex>
                <v-flex class="text-start">
                  <div class="one-line" style="font-size: 12px">
                    {{ item.project_title }}
                  </div>
                  <div class="one-line" style="font-size: 12px">
                    {{ $t("by") }}
                    {{ item.profile ? checkName(item.profile) : "" }}
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
        </slideritem>
        <!-- <slideritem
          v-for="(item, index) in someList"
          :key="index"
          style="width: 33.33%"
          class="pa-3"
        >
          
        </slideritem> -->

        <!-- Customizable loading -->
        <div slot="loading">loading...</div>
      </slider>
    </div>
  </div>
</template>

<script>
import { slider, slideritem } from "vue-concise-slider";
import { domain, imgPath } from "../../services/Constants";
import { mapState } from "vuex";

export default {
  props: {
    onClickCategory: Function,
    portfolios: {
      type: Array,
    },
    textBtn: {
      type: String,
      default: "Test",
    },
    iconBtn: {
      type: String,
      default: "Design",
    },
    colorBtn: {
      type: String,
      default: "1",
    },
    cateId: {
      type: String,
    },
    totalPortfolio: {
      type: Number,
      default: 0,
    },
  },
  components: {
    slider,
    slideritem,
  },
  data() {
    return {
      imgPath: imgPath,
      url: domain,
      model: null,
    };
  },
  computed: {
    ...mapState({
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),

    currentOptions: function() {
      if (this.$vuetify.breakpoint.smAndUp) {
        return {
          currentPage: 0,
          tracking: false,
          thresholdDistance: 100,
          thresholdTime: 300,
          infinite: 4,
          slidesToScroll: 3,
          loop: false,
          pagination: false,
        };
      } else {
        return {
          currentPage: 0,
          tracking: false,
          thresholdDistance: 100,
          thresholdTime: 300,
          infinite: 4,
          slidesToScroll: 1,
          loop: false,
          pagination: false,
        };
      }
    },
  },
  created() {},
  methods: {
    next(val) {
      this.$refs.slider.$emit("slideNext");
    },
    back(val) {
      this.$refs.slider.$emit("slidePre");
    },
    viewPortDetail(port) {
      // let slug =
      //   port.profile.mem_info && port.profile.mem_info.domain_name
      //     ? port.profile.mem_info.domain_name
      //     : port.profile.profile_id;
      // this.$router.push({
      //   path: `/detail-portfolio/${slug}`,
      //   query: { id: port.portfolio_id, pfid: port.profile.profile_id },
      // });
      let domain_slug =
        port.profile.mem_info && port.profile.mem_info.domain_name
          ? port.profile.mem_info.domain_name
          : port.profile.profile_id;
      this.$router.push({
        path: `/profile/${domain_slug}/${port.portfolio_id}`,
      });
    },
    checkIcon(iconName) {
      switch (iconName) {
        case "Design":
          return require("../../assets/icons/whiteIcon/การออกแบบ@2x.png");
        case "Architecture":
          return require("../../assets/icons/whiteIcon/สถาปัตยกรรม@2x.png");
        case "Fashion":
          return require("../../assets/icons/whiteIcon/แฟชั่น@2x.png");
        case "Craft":
          return require("../../assets/icons/whiteIcon/งานฝีมือ@2x.png");
        case "Advertising":
          return require("../../assets/icons/whiteIcon/การโฆษณา@2x.png");
        case "Visual Arts":
          return require("../../assets/icons/whiteIcon/ทัศนศิลป์@2x.png");
        case "Food":
          return require("../../assets/icons/whiteIcon/อาหารไทย@2x.png");
        case "Cultural and Heritage Tourism":
          return require("../../assets/icons/whiteIcon/การท่องเที่ยวเชิงวัฒนธรรม@2x.png");
        case "Film":
          return require("../../assets/icons/whiteIcon/ภาพยนต์@2x.png");
        case "Publishing":
          return require("../../assets/icons/whiteIcon/การพิมพ์@2x.png");
        case "Software":
          return require("../../assets/icons/whiteIcon/ซอฟแวร์@2x.png");
        case "Music":
          return require("../../assets/icons/whiteIcon/ดนตรี@2x.png");
        case "Performing Arts":
          return require("../../assets/icons/whiteIcon/ศิลปะการแสดง@2x.png");
        case "Broadcasting":
          return require("../../assets/icons/whiteIcon/การแพร่ภาพและกระจายเสียง@2x.png");
        case "Thai Traditional Medicine":
          return require("../../assets/icons/whiteIcon/การแพทย์แผนไทย@2x.png");
        default:
          return require("../../assets/icons/whiteIcon/ทั้งหมด@2x.png");
      }
    },
    checkName(val) {
      if (val.name_th && val.last_th) {
        if (val.name_th.length > 15) {
          return val.name_th;
        } else {
          return val.name_th + " " + val.last_th;
        }
      } else if (val.name_th && !val.last_th) {
        return val.name_th;
      } else if (val.name_en && val.last_en) {
        if (val.name_en.length > 15) {
          return val.name_en;
        } else {
          return val.name_en + " " + val.last_en;
        }
      } else if (val.name_en && !val.last_en) {
        return val.name_en;
      } else {
        return val.email;
      }
    },
  },
};
</script>

<style>
.menu-lists {
  border-radius: 5px;
  display: flex;
  justify-items: center;
  align-content: center;
  width: 100%;
  height: 40px;
  color: #fff;
  border-radius: 10px;
  /* background-color: #9c9c9c; */
}
.menu-lists:hover {
  cursor: pointer;
}

.icon_0 {
  background-color: #ef3e2e;
}
.icon_10 {
  background-color: #74bf92;
}
.icon_11 {
  background-color: #ac9277;
}
.icon_12 {
  background-color: #c98074;
}
.icon_1 {
  background-color: #957722;
}
.icon_9 {
  background-color: #e19705;
}
.icon_4 {
  background-color: #4cc2d2;
}
.icon_13 {
  background-color: #e47645;
}
.icon_15 {
  background-color: #8a233d;
}
.icon_5 {
  background-color: #cd4646;
}
.icon_7 {
  background-color: #92b4cb;
}
.icon_8 {
  background-color: #9f939a;
}
.icon_2 {
  background-color: #733c90;
}
.icon_3 {
  background-color: #684c41;
}
.icon_6 {
  background-color: #3b5fa6;
}
.icon_14 {
  background-color: #28645e;
}

@media only screen and (max-width: 600px) {
  .slide-width {
    width: 96% !important;
  }

  .slide-btn-pre {
    width: 35px;
    height: 35px;
    position: absolute;
    left: -7px;
    top: 15rem;
    z-index: 99999;
    box-shadow: 0 0 9px -2px #888888 !important;
    background-color: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slide-btn-next {
    width: 35px;
    height: 35px;
    z-index: 99999;
    position: absolute;
    right: -10px;
    top: 15rem;
    box-shadow: 0 0 9px -2px #888888 !important;
    background-color: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media only screen and (min-width: 768px) {
  .slide-width {
    width: 30.33% !important;
  }
  .slide-btn-pre {
    width: 35px;
    height: 35px;
    position: absolute;
    left: -7px;
    top: 10rem;
    z-index: 99999;
    box-shadow: 0 0 9px -2px #888888 !important;
    background-color: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slide-btn-next {
    width: 35px;
    height: 35px;
    z-index: 99999;
    position: absolute;
    right: 0;
    top: 10rem;
    box-shadow: 0 0 9px -2px #888888 !important;
    background-color: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media only screen and (min-width: 1366px) {
  .slide-width {
    width: 30.33% !important;
  }
  .slide-btn-pre {
    width: 35px;
    height: 35px;
    position: absolute;
    left: -7px;
    top: 10rem;
    z-index: 99999;
    box-shadow: 0 0 9px -2px #888888 !important;
    background-color: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slide-btn-next {
    width: 35px;
    height: 35px;
    z-index: 99999;
    position: absolute;
    right: 0;
    top: 10rem;
    box-shadow: 0 0 9px -2px #888888 !important;
    background-color: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media only screen and (min-width: 1600px) {
  .slide-width {
    width: 31.33% !important;
  }
  .slide-btn-pre {
    width: 35px;
    height: 35px;
    position: absolute;
    left: -7px;
    top: 10rem;
    z-index: 99999;
    box-shadow: 0 0 9px -2px #888888 !important;
    background-color: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slide-btn-next {
    width: 35px;
    height: 35px;
    z-index: 99999;
    position: absolute;
    right: 0;
    top: 10rem;
    box-shadow: 0 0 9px -2px #888888 !important;
    background-color: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media only screen and (min-width: 1920px) {
  .slide-width {
    width: 31.33% !important;
  }
  .slide-btn-pre {
    width: 35px;
    height: 35px;
    position: absolute;
    left: -7px;
    top: 10rem;
    z-index: 99999;
    box-shadow: 0 0 9px -2px #888888 !important;
    background-color: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slide-btn-next {
    width: 35px;
    height: 35px;
    z-index: 99999;
    position: absolute;
    right: 0;
    top: 10rem;
    box-shadow: 0 0 9px -2px #888888 !important;
    background-color: #fff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
